/**
 * Entry point: decides between the ERP and a store's website before loading either, so a shopper never downloads the
 * ERP. /shop/<slug> is a store on the platform's address. Any other address that is not one of the platform's own asks
 * the server once whether it is a store's verified domain; if not, it is the ERP (a customer's dedicated site).
 */
const PLATFORM_HOSTS = /^(localhost|127\.0\.0\.1|\[::1\]|(erp|accounts|expenses)\.cateyetech\.com|[^.]+\.vercel\.app)$/i;

async function start() {
  const shop = /^\/shop\/([a-z0-9-]+)(\/|$)/.exec(window.location.pathname);
  if (shop) return (await import('./store/boot')).boot({ site: shop[1]!, base: `/shop/${shop[1]!}` });
  if (!PLATFORM_HOSTS.test(window.location.hostname)) {
    const res = await fetch('/api/public/store/_/site', { credentials: 'omit' }).catch(() => null);
    if (res?.ok) return (await import('./store/boot')).boot({ site: '_', base: '' });
  }
  await import('./erp-boot');
}

void start();
